import styled from '@emotion/styled';
import { COLORS3, FONT, MEDIA_QUERY } from '../../styles/emotion';
import { LinkV2 } from '../LinkV2';

export const CategoryTiles = styled.ul`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 8px;
  row-gap: 16px;

  ${MEDIA_QUERY.MOBILE} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const TileLink = styled(LinkV2)`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  justify-content: center;
  row-gap: 8px;
  max-width: 160px;
`;

export const TileImage = styled.img`
  max-width: 100%;
  border-radius: 16px;
`;

export const TileName = styled.div`
  color: ${COLORS3.BLACK_100};
  font-size: ${FONT.FONT_SIZE_SMALL};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
`;
